export enum StatusRodadaEnum {
  STAND_BY = 'STAND_BY',
  ON = 'ON',
  SUCESSO = 'SUCESSO',
  VENCEU = 'VENCEU',
  CANCELADA = 'CANCELADA'
}

export enum StatusRodadaMascaraEnum {
  // RENDERIZAR NO HTML SEM CARACTERES ESPECIAIS
  STAND_BY = 'Stand by',
  ON = 'On',
  SUCESSO = 'Sucesso',
  VENCEU = 'Venceu',
  CANCELADA = 'Cancelada'
}
